module.exports = new __parcel__URL__("incidents-task-two-illustration.28222a25.png").toString();